module.exports = __webpack_public_path__ + "img/nftplay-shape-4.518f119d.png";